import { combineReducers } from "redux";

import { approval_info } from "pages/ApprovalManage/Module/reducers/view_reducer";

export const approvalServiceReducer = combineReducers({
  approval_info,
});
